import {
  CART_RESET,
  CART_FETCH_FULFILLED,
  CART_FETCH_PENDING,
  CART_ADD_ITEM_PENDING,
  CART_ADD_ITEM_FULFILLED,
  CART_ADD_ITEM_REJECTED,
  CART_ADD_VARIANT_PENDING,
  CART_ADD_VARIANT_FULFILLED,
  CART_ADD_VARIANT_REJECTED,
  CART_REMOVE_ITEM_PENDING,
  CART_REMOVE_ITEM_FULFILLED,
  CART_REMOVE_ITEM_REJECTED,
  CART_REMOVE_VARIANT_PENDING,
  CART_REMOVE_VARIANT_FULFILLED,
  CART_REMOVE_VARIANT_REJECTED,
  CART_UPDATE_ITEM_PENDING,
  CART_UPDATE_ITEM_FULFILLED,
  CART_UPDATE_ITEM_REJECTED,
  CART_UPDATE_FULFILLED,
  CART_UPDATE_PENDING,
  CART_UPDATE_REJECTED,
  CART_REFRESH_EDITION_PREVIEW_PENDING,
  CART_REFRESH_EDITION_PREVIEW_FULFILLED,
  CART_REFRESH_EDITION_PREVIEW_REJECTED,
  CART_EDITION_PREVIEW_UPDATED_FROM_EVENT,
} from 'actions/CartActions';

const initialState = {
  pending: false,
  addToCartPending:false,
  previewRefreshEditionIds: [],
  id: null,
  currency: 'EUR',
  items: [],
  sum_net: 0,
  sum_gross: 0,
  type: 'cart',
  vat_sum_rates: [],
};

export default function cart(state = initialState, action) {
  switch (action.type) {
    case CART_RESET: {
      return { ...initialState };
    }
    case CART_FETCH_FULFILLED: {
      return { ...state, ...action.payload.data, pending: false };
    }

    case CART_FETCH_PENDING: {
      return { ...state, pending: true };
    }

    case CART_ADD_ITEM_PENDING:
    case CART_ADD_VARIANT_PENDING: {
      return { ...state, pending: true, addToCartPending: true };
    }

    case CART_ADD_ITEM_FULFILLED: {
      return { ...state, ...action.payload.data, pending: false, addToCartPending: false };
    }

    case CART_ADD_VARIANT_FULFILLED: {
      return { ...state, ...action.payload.data, pending: false };
    }

    case CART_ADD_ITEM_REJECTED:
    case CART_ADD_VARIANT_REJECTED: {
      return { ...state, pending: false };
    }

    case CART_REMOVE_ITEM_PENDING:
    case CART_REMOVE_VARIANT_PENDING: {
      return { ...state, pending: true };
    }

    case CART_REMOVE_ITEM_FULFILLED: {
      return { ...state, ...action.payload.data, pending: false };
    }

    case CART_REMOVE_VARIANT_FULFILLED: {
      return { ...state, ...action.payload.data, pending: false };
    }

    case CART_REMOVE_ITEM_REJECTED:
    case CART_REMOVE_VARIANT_REJECTED: {
      return { ...state, pending: false };
    }

    case CART_UPDATE_ITEM_FULFILLED: {
      return { ...state, ...action.payload.data, pending: false };
    }

    case CART_UPDATE_ITEM_PENDING: {
      return { ...state, pending: true };
    }

    case CART_UPDATE_ITEM_REJECTED: {
      return { ...state, pending: false };
    }

    case CART_UPDATE_FULFILLED: {
      return { ...state, ...action.payload.data, pending: false };
    }

    case CART_UPDATE_PENDING: {
      return { ...state, pending: true };
    }

    case CART_UPDATE_REJECTED: {
      return { ...state, pending: false };
    }

    case CART_REFRESH_EDITION_PREVIEW_PENDING: {
      const editionId = action.meta?.editionId;
      if (!editionId) {
        return state;
      }

      return {
        ...state,
        previewRefreshEditionIds: [...state.previewRefreshEditionIds, editionId],
      };
    }

    case CART_REFRESH_EDITION_PREVIEW_FULFILLED: {
      const { editionId, edition } = action.payload;

      return {
        ...state,
        previewRefreshEditionIds: state.previewRefreshEditionIds.filter(id => id !== editionId),
        items: state.items.map(item => {
          if (item.edition?.id !== editionId) {
            return item;
          }

          return {
            ...item,
            edition: {
              ...item.edition,
              previews: edition.previews,
              previews_state: edition.previews_state,
              mdate: edition.mdate,
            },
          };
        }),
      };
    }

    case CART_REFRESH_EDITION_PREVIEW_REJECTED: {
      const editionId = action.meta?.editionId;

      return {
        ...state,
        previewRefreshEditionIds: editionId
          ? state.previewRefreshEditionIds.filter(id => id !== editionId)
          : state.previewRefreshEditionIds,
      };
    }

    case CART_EDITION_PREVIEW_UPDATED_FROM_EVENT: {
      const { editionId, eventPayload } = action.payload || {};
      if (!editionId || !Array.isArray(eventPayload?.previews)) {
        return state;
      }

      const previewsState = eventPayload.previewsState ?? eventPayload.previews_state;

      return {
        ...state,
        items: state.items.map(item => {
          if (item.edition?.id !== editionId) {
            return item;
          }

          return {
            ...item,
            edition: {
              ...item.edition,
              previews: eventPayload.previews,
              ...(previewsState !== undefined ? { previews_state: previewsState } : {}),
              ...(eventPayload.mdate !== undefined ? { mdate: eventPayload.mdate } : {}),
            },
          };
        }),
      };
    }
  }

  return state;
}
